import React from 'react';
import cls from 'classnames';
import { FormGroupColumn } from '../common/forms/FormElements';
import CrewMemberStartTimeButton from './CrewMemberStartTimeButton';
import {
    getDisplayedCrewOverrideStartTime,
    getPersistedCrewOverrideStartTime,
    hasPersistedCrewOverrides,
    updateCrewOverrideStartTimes,
} from './CrewDisplayHelpers';

export default class CrewEquipmentDisplay extends React.Component {
    onCrewEquipmentChanged = (equipmentId) => {
        const { job, onCrewComponentsChanged } = this.props;
        let crewEquipmentMemberships = [
            ...(job?.crewEquipmentMemberships || []),
        ];

        if (crewEquipmentMemberships.includes(equipmentId)) {
            crewEquipmentMemberships = crewEquipmentMemberships.filter(
                (ceqi) => ceqi && ceqi != equipmentId
            );
        } else {
            crewEquipmentMemberships.push(equipmentId);
        }

        onCrewComponentsChanged(null, crewEquipmentMemberships);
    };

    updateOverrideStartTimes = (overrideKey, idKey, resourceId, value) =>
        updateCrewOverrideStartTimes(
            this.props.job,
            this.props.onCrewComponentsChanged,
            overrideKey,
            idKey,
            resourceId,
            value
        );

    getEquipmentType = (equipment) => {
        const { equipmentTypes } = this.props;
        const equipmentType = equipmentTypes.find(
            (type) => equipment.equipmentTypeId == type.id
        );

        return equipmentType.description;
    };

    render() {
        const {
            crew,
            equipments,
            job,
            disabled,
            onCrewComponentsChanged,
            jobResourceOverrides,
        } = this.props;

        if (!crew) {
            return null;
        }

        const crewEquipments = (equipments || []).filter((equipment) =>
            crew.crewEquipmentMemberships.includes(equipment.id)
        );
        const crewEquipmentMemberships = job?.crewEquipmentMemberships || [];
        const editMode = Boolean(
            onCrewComponentsChanged &&
            job?.crewEmployeeMemberships &&
            job?.crewEquipmentMemberships &&
            !disabled
        );
        const showEquipmentStartTimes =
            editMode ||
            hasPersistedCrewOverrides(jobResourceOverrides, 'equipmentId');

        return (
            <FormGroupColumn>
                <label className="control-label">Equipment</label>
                <table className="table table-striped table-sm">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Type</th>
                            {showEquipmentStartTimes && <th>Start Time</th>}
                            {editMode && <th>Selected</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {crewEquipments.map((crewEquipment) => (
                            <tr
                                key={`crewEquipmentTr${crewEquipment.id}`}
                                onClick={() => {
                                    if (editMode) {
                                        this.onCrewEquipmentChanged(
                                            crewEquipment.id
                                        );
                                    }
                                }}
                                className={cls('crew-display-equipment', {
                                    'deselected-component':
                                        editMode &&
                                        !job.crewEquipmentMemberships.includes(
                                            crewEquipment.id
                                        ),
                                    'disabled-component': disabled,
                                })}
                            >
                                <td>
                                    {crewEquipment.description} (
                                    {crewEquipment.identifier})
                                </td>
                                <td>{this.getEquipmentType(crewEquipment)}</td>
                                {showEquipmentStartTimes && (
                                    <td onClick={(e) => e.stopPropagation()}>
                                        {editMode ? (
                                            <CrewMemberStartTimeButton
                                                value={getDisplayedCrewOverrideStartTime(
                                                    job,
                                                    jobResourceOverrides,
                                                    'equipmentOverrideStartTimes',
                                                    'equipmentId',
                                                    crewEquipment.id
                                                )}
                                                onChange={(value) =>
                                                    this.updateOverrideStartTimes(
                                                        'equipmentOverrideStartTimes',
                                                        'equipmentId',
                                                        crewEquipment.id,
                                                        value
                                                    )
                                                }
                                                label={`${crewEquipment.description} (${crewEquipment.identifier})`}
                                                disabled={disabled}
                                            />
                                        ) : (
                                            getPersistedCrewOverrideStartTime(
                                                jobResourceOverrides,
                                                'equipmentId',
                                                crewEquipment.id
                                            ) || ''
                                        )}
                                    </td>
                                )}
                                {editMode && (
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={crewEquipmentMemberships.includes(
                                                crewEquipment.id
                                            )}
                                            readOnly={true}
                                        />
                                    </td>
                                )}
                            </tr>
                        ))}

                        {!crewEquipments.length && (
                            <tr>
                                <td colSpan={3}>
                                    No equipment assigned to crew.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </FormGroupColumn>
        );
    }
}
